module.exports = __webpack_public_path__ + "img/boby.4e5db27a.png";